import { ActionType } from '@enums/node-types.enum';
import { GameUIAction, UiActionType } from '@models/game-ui-actions';

export type ActionHandler = (payload?: unknown) => unknown | Promise<unknown>;

export default class ActionMap {
  private handlers = new Map<string, ActionHandler>();

  register(name: UiActionType, handler: ActionHandler): void {
    if (!name || typeof handler !== 'function') {
      throw new TypeError('Invalid action registration');
    }
    this.handlers.set(name, handler);
  }

  has(name: ActionType): boolean {
    return this.handlers.has(name);
  }

  async execute<T = unknown>(
    name: UiActionType,
    action: GameUIAction,
  ): Promise<T> {
    const fn = this.handlers.get(name);
    if (!fn) throw new Error(`No handler registered for action "${name}"`);

    try {
      return (await fn(action)) as T;
    } catch (e) {
      throw new Error(`Action "${name}" failed: ${(e as Error).message}`);
    }
  }

  clear(): void {
    this.handlers.clear();
  }
}
